import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Loader2 } from "lucide-react";

interface AiImportProgressProps {
  jobId?: string;
  progressPct?: number;
  message?: string;
  onAbort?: () => void;
  filenames?: string[];
}

export function AiImportProgress({ jobId, progressPct = 10, message = "Scanning the file for assets...", onAbort, filenames = [] }: AiImportProgressProps) {
  return (
    <div className="p-6 md:p-7">
      <div className="flex items-center justify-between mb-4">
        <div>
          <div className="text-xs uppercase tracking-wide text-muted-foreground">AI Import</div>
          <h2 className="text-xl font-semibold">Processing Upload</h2>
        </div>
        <Button variant="outline" size="sm" onClick={onAbort} disabled={!jobId}>Abort</Button>
      </div>

      <p className="text-sm text-muted-foreground mb-3">{message}</p>

      <div className="flex items-center gap-2 mb-2">
        <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />
        {jobId ? (
          <span className="text-xs text-muted-foreground">Job ID: {jobId.slice(0, 8)}…</span>
        ) : (
          <span className="text-xs text-muted-foreground">Preparing upload…</span>
        )}
        {Array.isArray(filenames) && filenames.length > 0 && (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Badge variant="secondary" className="text-[10px] cursor-default">{filenames.length} file{filenames.length>1?"s":""}</Badge>
              </TooltipTrigger>
              <TooltipContent className="max-w-[320px]">
                <div className="text-xs space-y-1">
                  {filenames.map((n, i) => (
                    <div key={i} className="truncate">{n}</div>
                  ))}
                </div>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
      </div>

      <Progress value={progressPct} className="h-2" />

      <p className="mt-8 text-xs text-muted-foreground">Hang tight, it might take a couple minutes to extract the data.</p>
    </div>
  );
}

export default AiImportProgress;
